import React, { useEffect, useState } from 'react'
import AddLayout from '../../../../component/AddLayout'
import { Autocomplete, Box, Button, FormControl, MenuItem, OutlinedInput, Select, TextField } from '@mui/material'
import DatePicker from '../../../../component/DatePicker'
import dayjs from 'dayjs'
import RequireField from '../../../../component/RequireField'
import { faArrowLeft, faMinusCircle, faPlusCircle } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useSelector } from 'react-redux'
import { CalQtySack, GetBreedClassNo, GetSeasonNo, StockStatus } from '../../services/stockService';
import { addReceives, getItemMasterList, getLatestLot, getZones } from '../../services/api'
import ConfirmDialogReceive from '../../component/confirmDialogReceive'
import { useNavigate } from 'react-router-dom'
import Swal from 'sweetalert2'

export default function StockReceiveAdd() {
    const { profile } = useSelector(state => state.profile)
    const navigate = useNavigate();

    const [receiveDate, setReceiveDate] = useState(dayjs(new Date()))
    const [refNo, setRefNo] = useState('')
    const [refNoError, setRefNoError] = useState(false)
    const [remark, setRemark] = useState('')
    const [items, setItems] = useState([])
    const [branchs, setBranchs] = useState([])
    const [lastLot, setLastLot] = useState()
    const [open, setOpen] = useState(false);
    const [loadingSubmit, setLoadingSubmit] = useState(false);

    const [rows, setRows] = useState([
        {
            id: 0,
            ItemName: "",
            Year: '',
            Season: "",
            Lot: "",
            Qty: '',
            UnitNo: "",
            ModifiedDate: null,
            WarehouseNo: "",
            ZoneNo: "",
            SalePrice: 0,
            CostPrice: 0,
            ItemNo: null
        }
    ]);
    function addRow() {
        const newRow = {
            id: rows?.slice(-1)[0]?.id ? rows?.slice(-1)[0]?.id + 1 : 1,
            ItemName: "",
            Year: '',
            Season: "",
            Lot: "",
            Qty: '',
            UnitNo: "",
            ModifiedDate: null,
            WarehouseNo: "",
            ZoneNo: "",
            SalePrice: 0,
            CostPrice: 0,
            ItemNo: null
        };

        setRows([...rows, newRow]);
    }
    const deletehand = (i) => {
        const data = rows?.filter((e) => i !== e?.id);
        setRows(data);
    };


    const getLastLot = async (prefix) => {
        const data = await getLatestLot(prefix)
        setLastLot(data)
    }
    useEffect(() => {
        const getZonesList = async () => {
            const data = await getZones(profile?.BranchNo?.BranchNo)
            setBranchs(data)
        }
        getZonesList()
    }, [profile])
    useEffect(() => {
        const getItemList = async () => {
            const data = await getItemMasterList()
            setItems(data)
        }
        getItemList()
    }, [])

    const receiveAdd = async (body) => {
        setLoadingSubmit(true)
        const post = async () => {
            const res = await addReceives(body)
            if (res) {
                setLoadingSubmit(false)
                setOpen(false)
                navigate('/stock/stock-receive/' + res.ReceiveNo, { state: { new: true } })
            } else {
                Swal.fire({
                    title: 'ทำรายการไม่สำเร็จ',
                    icon: 'warning',
                })
                setLoadingSubmit(false)
            }
        }
        post()
    }

    const handleSubmit = (e) => {

        if (!refNo) {
            setRefNoError(true)
        }
        if (rows?.filter((x) => !x?.ItemNo)) {
            const item = rows?.map((v, index) => {
                v.LotError = v.ItemNo ? false : true
                return v;

            });
            setRows([...item]);
        }
        if (rows?.filter((x) => x?.Year?.length < 1)) {
            const item = rows?.map((v, index) => {
                v.YearError = v?.Year?.length >= 1 ? false : true
                return v;

            });
            setRows([...item]);
        }

        if (rows?.filter((x) => x?.Lot?.length < 3)) {
            const item = rows?.map((v, index) => {
                v.LotGenError = v.Lot?.length >= 3 ? false : true
                return v;

            });
            setRows([...item]);
        }
        if (rows?.filter((x) => x?.WarehouseNo?.length < 1)) {
            const item = rows?.map((v, index) => {
                v.WarehouseError = v.WarehouseNo ? false : true
                return v;

            });
            setRows([...item]);
        }
        if (refNo && rows?.filter((x) => !x?.ItemNo).length === 0 && rows?.filter((x) => x?.Year?.length < 1).length === 0 && rows?.filter((x) => x?.Lot?.length < 3).length === 0 && rows?.filter((x) => x?.WarehouseNo?.length < 1).length === 0) {
            setOpen(true)
        }
    }
    const handleAdd = () => {

        const body = {
            BranchNo: profile?.BranchNo?.BranchNo,
            RefNo: refNo,
            DocumentDate: dayjs(new Date()).format('YYYY-MM-DD'),
            ReceiveDate: dayjs(receiveDate).format('YYYY-MM-DD'),
            Remark: remark,
            Status: 'Y',
            ReceiveDetails: rows?.map((x) => (
                {
                    ItemNo: x?.ItemNo?.ItemNo,
                    Year: +x?.Year,
                    Season: x?.ItemNo?.Season,
                    Lot: x?.LotGen + x?.Lot,
                    Qty: +x?.Qty.toString().replaceAll(',', ''),
                    UnitNo: x?.ItemNo?.UnitNo?.UnitNo,
                    ModifiedDate: dayjs(new Date()).format('YYYY-MM-DD'),
                    WarehouseNo: x?.WarehouseNo,
                    ZoneNo: x?.ZoneNo,
                    SalePrice: +x?.ItemNo?.SalePrice,
                    CostPrice: +x?.CostPrice
                }
            ))
        }

        receiveAdd(body)

    }
    const inputHead = [
        {
            name: 'วันรับเมล็ดพันธุ์เข้าคลัง',
            inputComponent: <><DatePicker value={receiveDate} onChange={e => setReceiveDate(e)} disabled={false} /></>,
        },
        {
            name: 'เลขที่อ้างอิง',
            inputComponent: <>
                <RequireField value={refNo} onChange={setRefNo} type={'text'} disabled={false} error={refNoError} setError={setRefNoError} textError={'กรุณากรอกเลขที่อ้างอิง'} />
            </>,
        },
    ]
    const head = [
        'ที่',
        'เมล็ดพันธุ์',
        'ชั้นพันธุ์',
        'ฤดู',
        'กลุ่มพันธุ์',
        'สารเคมี',
        'ปีที่ผลิต',
        'ล็อตที่',
        'จำนวน (กระสอบ)',
        'ปริมาณ',
        'หน่วย',
        'โรงเก็บที่',
        'ราคาจำหน่าย',
        'ต้นทุนการผลิต',
        ''
    ]
    const body = rows?.map((x, i) => {
        return {
            item1: i + 1,
            item2: <><Autocomplete
                size='small'
                options={items}
                getOptionLabel={(option) => option?.ItemName}
                onBlur={e => {
                    const item = rows?.map((v, index) => {
                        v.LotError = index === i ? x.ItemNo ? false : true : v?.LotError;
                        return v;
                    });
                    setRows([...item]);
                }
                }
                componentsProps={{
                    paper: {
                        sx: {
                            width: 500
                        }
                    }
                }}
                renderOption={(props, option) => (
                    <Box component="li" {...props} key={option.ItemNo}>
                        {option?.CatalogNo?.CatalogName} {option?.Option2} <span style={{ color: option?.Season === 'ฝน' ? '#0D9206' : 'brown', fontWeight: 'bold', margin: '0 10px' }}>{option?.Season}</span> {option?.Option1} {option?.Chemical}
                    </Box>
                )}
                value={x?.ItemNo}
                onChange={(event, newValue) => {
                    const item = rows?.map((v, index) => {
                        v.LotGen = index === i ? null : v?.LotGen;
                        v.ItemNo = index === i ? newValue : v?.ItemNo;
                        v.Year = index === i ? '' : v?.Year;
                        v.Lot = index === i ? '' : v?.Lot;

                        return v;

                    });
                    setRows([...item]);

                }}

                renderInput={(params) => (
                    <Box ref={params.InputProps.ref}>
                        <OutlinedInput error={!x?.LotError ? false : true} {...params.inputProps} fullWidth size='small' sx={{ padding: '0 !important', background: '#fff' }} />
                    </Box>
                )}
            />
                {!x?.LotError ? '' : <span style={{ color: 'red', fontSize: '12px', position: 'absolute', left: '8px' }}>กรุณาเลือกเมล็ดพันธุ์</span>}</>,
            item3: x?.ItemNo?.Option2,
            item4: <span style={{ color: x?.ItemNo?.Season === 'ฝน' ? '#0D9206' : 'brown', fontWeight: 'bold' }}>{x?.ItemNo?.Season}</span>,
            item5: x?.ItemNo?.Option1,
            item6: x?.ItemNo?.Chemical,
            item7: <>
                <TextField className='w-70' error={!x?.YearError ? false : true} onBlur={e => {
                    const item = rows?.map((v, index) => {
                        v.YearError = index === i ? x.Year ? false : true : v?.YearError;
                        return v;

                    });
                    setRows([...item]);
                }
                } value={x?.Year || ''}
                    size='small' variant='outlined' onChange={e => {
                        const branchNo = profile?.BranchNo?.BranchNo
                        const breedClassNo = GetBreedClassNo(x?.ItemNo?.Option2)
                        const seasonNo = GetSeasonNo(x?.ItemNo?.Season)
                        const lotNumber = branchNo + breedClassNo + seasonNo + e.target.value;
                        const item = rows?.map((v, index) => {
                            v.Year = index === i ? e.target.value : v?.Year;
                            v.LotGen = index === i ? lotNumber : v?.LotGen
                            return v;

                        });
                        setRows([...item]);
                        getLastLot(x?.LotGen)
                    }}
                    sx={{ background: '#fff' }}
                    inputProps={{ maxLength: 2 }}
                    onKeyPress={(event) => {
                        if (!/[0-9]/.test(event.key)) {
                            event.preventDefault();
                        }
                    }} />
                {!x?.YearError ? '' : <span style={{ color: 'red', fontSize: '12px', position: 'absolute', bottom: '-8px', left: "8px" }}>กรุณากรอกปี</span>}</>,
            item8: <>
                <Box sx={{
                    display: 'flex', '& .MuiTextField-root': {
                        color: 'red',
                        '& .MuiOutlinedInput-root': { borderRadius: '0 .25rem .25rem 0' }
                    }
                }}>
                    <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        padding: '.375rem .75rem',
                        fontSize: '1rem',
                        fontWeight: '400',
                        lineHeight: '1.5',
                        color: '#212529',
                        textAlign: 'center',
                        whiteApace: 'nowrap',
                        backgroundColor: '#e9ecef',
                        border: '1px solid #ced4da',
                        borderRadius: '.25rem 0 0 .25rem',

                    }}>{x?.LotGen}</div>
                    <TextField sx={{ width: '100px' }} error={!x?.LotGenError ? false : true}
                        onBlur={e => {
                            const item = rows?.map((v, index) => {
                                v.LotGenError = index === i ? x.Lot.length === 3 ? false : true : v?.LotGenError;
                                return v;

                            });
                            setRows([...item]);
                        }} value={x?.Lot || ''}
                        inputProps={{ maxLength: 3 }}
                        size='small' fullWidth variant='outlined' onChange={e => {
                            const item = rows?.map((v, index) => {
                                v.Lot = index === i ? e.target.value : v?.Lot;
                                return v;

                            });
                            setRows([...item]);
                        }} onKeyPress={(event) => {
                            if (!/[0-9]/.test(event.key)) {
                                event.preventDefault();
                            }
                        }} />

                </Box>
                {!x?.LotGenError || lastLot ? '' : <span style={{ color: 'red', fontSize: '12px', position: 'absolute', bottom: '-16px' }}>กรุณากรอกเลขล็อต</span>}
                {lastLot && <span style={{ fontSize: '12px', position: 'absolute', bottom: '-8px', left: '8px' }}>{`Lotล่าสุด  ${lastLot}`}</span>}
            </>,
            item9: CalQtySack(x?.ItemNo?.Option2, +x.Qty.toString().replaceAll(',', '')),
            item10: <TextField value={x?.Qty.toLocaleString()}
                sx={{ background: '#fff', width: '120px' }}
                type='tel' size='small' fullWidth variant='outlined' onChange={e => {
                    let newValue = e.target.value.replace(/,/g, "");

                    let abc = newValue.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
                    const item = rows?.map((v, index) => {
                        v.Qty = i === index ? abc : v?.Qty;
                        return v;

                    });
                    setRows([...item]);
                }} onKeyPress={(event) => {
                    if (!/[0-9]/.test(event.key)) {
                        event.preventDefault();
                    }
                }} />,
            item11: x?.ItemNo?.UnitNo?.UnitName,
            item12: <>
                <FormControl className='w-120' variant="outlined" size='small' fullWidth
                    error={x?.WarehouseError}
                >
                    <Select value={x?.ZoneNo} onChange={e => {
                        const item = rows?.map((v, index) => {
                            v.WarehouseNo = i === index ? branchs?.find((x) => x?.ZoneNo === e.target.value)?.WarehouseNo?.WarehouseNo : v?.WarehouseNo;
                            v.ZoneNo = i === index ? branchs?.find((x) => x?.ZoneNo === e.target.value).ZoneNo : v?.ZoneNo
                            v.WarehouseName = i === index ? `${branchs?.find((x) => x?.ZoneNo === e.target.value)?.WarehouseNo?.WarehouseName} ${branchs?.find((x) => x?.ZoneNo === e.target.value)?.ZoneName}` : v?.WarehouseName
                            return v;

                        });
                        setRows([...item]);
                    }} onBlur={e => {
                        const item = rows?.map((v, index) => {
                            v.WarehouseError = index === i ? x.WarehouseNo ? false : true : v?.WarehouseError;
                            return v;

                        });
                        setRows([...item]);
                    }} >
                        {branchs?.map((z, i) => (
                            <MenuItem value={z?.ZoneNo}>{z?.WarehouseNo?.WarehouseName} {z?.ZoneName}</MenuItem>
                        ))}
                    </Select>
                </FormControl>
                {!x?.WarehouseError ? '' : <span style={{ color: 'red', fontSize: '12px', position: 'absolute', bottom: '-6px', left: "8px" }}>กรุณาเลือกโรงเก็บ</span>}
            </>,
            item13: x?.ItemNo?.SalePrice,
            item14:
                <TextField sx={{ width: '150px' }} type='number' value={x?.CostPrice} size='small' fullWidth variant='outlined' onChange={e => {

                    const item = rows?.map((v, index) => {
                        v.CostPrice = i === index ? e.target.value : v?.CostPrice;
                        return v;

                    });
                    setRows([...item]);
                }} />,
            item15: <FontAwesomeIcon icon={faMinusCircle} onClick={() => deletehand(i)} />
        }
    })
    return (
        <AddLayout
            title={'ข้อมูลรับเมล็ดพันธุ์ดี'}
            inputHead={inputHead}
            inputRemark={
                <div class="col-lg-10 col-md-12">
                    <label class="labelInput">หมายเหตุ</label>
                    <Box className='backgroundField' sx={{ marginBottom: '10px', borderRadius: '25px' }}>
                        <TextField value={remark} onChange={e => setRemark(e.target.value)} variant="standard" fullWidth multiline rows={3} disabled={false}
                            InputProps={{
                                disableUnderline: true,
                            }}
                        />
                    </Box>
                </div>}
            bodyTitle={'รายการรับเมล็ดพันธุ์ดี'}
            bodyAction={<FontAwesomeIcon icon={faPlusCircle} onClick={addRow} />}
            tableHead={head}
            tableBody={body}
            bootomAction={<>
                <Button onClick={() => navigate(-1)} variant='outlined'
                    startIcon={<FontAwesomeIcon icon={faArrowLeft} />}
                    sx={{ width: '130px', fontSize: '14px', marginRight: '10px' }}>กลับ</Button>
                <Button variant='contained' onClick={() => handleSubmit(StockStatus?.Active)} sx={{ width: '130px', fontSize: '14px' }}>{'บันทึก'}</Button>
            </>}
            dialog={<ConfirmDialogReceive open={open} setOpen={setOpen} rows={rows} handleAdd={handleAdd} loadingSubmit={loadingSubmit} />} />
    )
}
